import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, commsHeader, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { UPDATE_COMS_CONFIG, UPDATE_COMS_CONFIG_SUCCESS, UPDATE_COMS_CONFIG_ERROR, UPDATE_ATTRIBUTE_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* updateComsConfig({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/comms/configs/${payload?.params}`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        ...commsHeader,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: UPDATE_COMS_CONFIG_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.success(response?.response?.data?.message);
      yield put({
        type: UPDATE_COMS_CONFIG_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_ATTRIBUTE_ERROR, payload: error });
  }
}

export function* watchUpdateComsConfig() {
  yield takeEvery(UPDATE_COMS_CONFIG, updateComsConfig);
}

function* updateComsConfigSaga() {
  yield all([fork(watchUpdateComsConfig)]);
}

export default updateComsConfigSaga;
